const About = () => {
	return (
		<>
			<div className="wrapper">
				<h1 className="t_vote">About us.</h1>
				<hr></hr>
				<p style={{ maxWidth: "50ch" }}>
					We are a SaaS based Blockchain Enterprise dedicated to handling secure
					smart contracts with our users to ensure their data security and
					privacy while also contributing to the open economy of the United
					States of America by reducing the amount of Inflation by using a run
					on sentence that does not have any punctuation in it.
				</p>
				<br></br>
				<br></br>
				<p style={{ maxWidth: "50ch" }}>
					We want our users to have their interest piqued and their questions
					answered. So our portal needs to combine information, "magic moments"
					and links to the brilliant community resources that exist out there.
					The purpose of our content is to be an “onboarding portal” and not a
					substitute for the extensive resources that already exist. We're keen
					to support and integrate with community built resources, giving them
					more visibility and making them more discoverable.
				</p>
				<br></br>
				<br></br>
				<br></br>
			</div>
		</>
	);
};

export default About;
